import { FC, Fragment, KeyboardEvent, MouseEvent, useContext } from 'react'
import { ScreenContext } from 'react-components'

import { UserMenuModal, UserMenuWidget } from './styles'
import { Role } from '../types'
import { NavigationTransport } from '../../../../transports/common/navigation-section-transport'
import { useTranslation } from '../../../../hooks/locale'
import UserMenuContent from './user-menu-content'
import UserDetailsModel from '../../../../models/user/user-details-model'
import ModalHeader from '../../../common/modal/modal-header'

interface Props {
    isOpen: boolean
    toggleOpen: (event: MouseEvent | KeyboardEvent) => void
    userDetails: UserDetailsModel
    navigation: NavigationTransport
}

const UserMenu: FC<Props> = ({ isOpen, toggleOpen, userDetails, navigation }) => {
    const { tfwPrimaryRole: userRole, firstName, inquiryCount } = userDetails

    const { isDesktop } = useContext(ScreenContext)
    const { t } = useTranslation()

    return (
        <Fragment>
            {isDesktop ? (
                <UserMenuWidget isOpen={isOpen}>
                    <UserMenuContent navigation={navigation} userRole={userRole} inquiryCount={inquiryCount} />
                </UserMenuWidget>
            ) : (
                <UserMenuModal isOpen={isOpen} onRequestClose={toggleOpen} closeTimeoutMS={550}>
                    <ModalHeader
                        title={`${t('userGreet')} ${firstName.slice(0, 12)}`}
                        subtitle={t('userSubText').replace(
                            ':user',
                            userRole === Role.CUSTOMER ? t('landlord') : t('guest'),
                        )}
                        onClose={toggleOpen}
                    />
                    <UserMenuContent navigation={navigation} userRole={userRole} inquiryCount={inquiryCount} />
                </UserMenuModal>
            )}
        </Fragment>
    )
}

export default UserMenu
